import React, { useState, useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Admin from "../store/ducks/admin.duck";
import * as Forms from "../store/ducks/forms.duck";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import {
  Grid,
  TableContainer,
  FormControl,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  makeStyles,
  Tooltip,
  IconButton,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import PublishIcon from "@material-ui/icons/Publish";
import { format } from "date-fns";
import FormDataEntry from "../pages/home/admin/FormDataEntry";
import CloseIcon from "@material-ui/icons/Close";
import CloudDownload from "@material-ui/icons/CloudDownload";
import ReactQuill from "react-quill";
import { CircularProgress } from "@material-ui/core";
import "../../_metronic/_assets/css/app2.css";
import "react-quill/dist/quill.snow.css";

export default function Notes(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchNotes({ type: props.type, pkID: props.pkid }));
  }, [dispatch, props.type, props.pkid]);
  // useEffect( () => { dispatch(Admin.actions.fetchCounter()) }, [dispatch] )
  useEffect(() => {
    dispatch(Forms.actions.fetchForms());
  }, [dispatch]);
  useEffect(() => {
    if (props.pkid > 0) dispatch(Admin.actions.fetchFiles({ type: props.type, pkID: props.pkid }));
  }, [dispatch, props.type, props.pkid]);

  const files = useSelector((state) => state.admin.Files[props.type]);
  const loadFiles = files.filter((file) => file.formData === null);
  const [newNote, setNewNote] = useState("");
  const [csNotifyPrimary, setcsNotifyPrimary] = useState(false);
  const [csNotifyAdmin, setcsNotifyAdmin] = useState(false);
  const [csNotifyProvider, setcsNotifyProvider] = useState(false);
  const [footer, setFooter] = useState(props.waitingRoomURL);
  const [viewType, setViewType] = useState(props.viewType ? props.viewType : "ALL");
  const [newNoteHelpText, setNewNoteHelpText] = useState("");
  const [emailSubjectHelpText, setEmailSubjectHelpText] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [emailCC, setEmailCC] = useState("");
  const [emailCCHelpText, setEmailCCHelpText] = useState("");
  const [noteSelector, setnoteSelector] = useState(props.noteAction ? props.noteAction : props.viewType !== "CommunicationOnly" ? "Note" : "Email");
  const [newFFile, setNewFFile] = useState();
  const [existingFile, setExistingFile] = useState(0);
  const [attachmentHelpText, setAttachmentHelpText] = useState("");
  const [faxDestination, setFaxDestination] = useState((props.medicalPractice && props.medicalPractice.fax) || "");
  const [faxDestinationHelpText, setFaxDestinationHelpText] = useState("");
  const [sendFormID, setSendFormID] = useState(0);
  const [formHelpText, setFormHelpText] = useState("");
  const [show, setShow] = useState(false);
  const [reportType, setReportType] = useState("Not Set");
  const [reportTypeHelpText, setReportTypeHelpText] = useState("");

  const notes = useSelector((state) => state.admin.Notes[props.type]);
  const onlyNotes = (notes || []).filter(
    (note) => note.action === "Note" || note.action === "Request Report" || note.action === "Request SCC" || note.action === "Add Report",
  );
  const onlyCommunications = (notes || []).filter(
    (note) => note.action !== "Note" && note.action !== "Request Report" && note.action !== "Request SCC" && note.action !== "Add Report",
  );
  const role = useSelector((state) => state.auth.roleDesc);
  const forms = useSelector((state) => state.forms.Forms);
  const notesToDisplay = viewType === "NoteOnly" ? onlyNotes : viewType === "CommunicationOnly" ? onlyCommunications : notes;

  // File Download Fields and Status
  const fetchFileDownload = useSelector((state) => state.admin.FetchFileDownloadNotes);
  const fetchFileDownloadStatus = useSelector((state) => state.admin.FetchFileDownloadNotesStatus);
  const [downloadFileName, setDownloadFileName] = useState("");
  const [activeFileDownloadId, setActiveFileDownloadId] = useState(null);

  function validateEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  const getFileExtension = (filename) => {
    if (!filename) return "";
    const parts = filename.split(".");
    return parts.length > 1 ? parts.pop().toLowerCase() : "";
  };

  const getMimeType = (extension) => {
    const mimeTypes = {
      pdf: "application/pdf",
      doc: "application/msword",
      docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      xls: "application/vnd.ms-excel",
      xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      csv: "text/csv",
      txt: "text/plain",
      jpg: "image/jpeg",
      jpeg: "image/jpeg",
      png: "image/png",
      gif: "image/gif",
      zip: "application/zip",
    };

    return mimeTypes[extension] || "application/octet-stream";
  };

  const handleFileDownload = (row) => {
    console.log("Row:", row);
    setDownloadFileName(row.filename);
    setActiveFileDownloadId(row.reportFileID);
    dispatch(
      Admin.actions.fetchFileDownloadNotes({
        type: props.type,
        pkid: props.pkid,
        fileID: row.reportFileID,
      }),
    );
  };

  // Look for file download completion and trigger download if ready
  useEffect(() => {
    if (fetchFileDownloadStatus === "Fetched" && fetchFileDownload && fetchFileDownload.filerequested) {
      downloadFile();
      setActiveFileDownloadId(null);
      dispatch(Admin.actions.resetFileDownloadNotesStatus());
    }
  }, [fetchFileDownloadStatus, fetchFileDownload, downloadFile, dispatch]);

  // This is used to download Files in whatever format
  const downloadFile = useCallback(() => {
    if (fetchFileDownload && fetchFileDownload.filerequested) {
      const byteCharacters = atob(fetchFileDownload.filerequested);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      const extension = getFileExtension(downloadFileName);
      const mimeType = getMimeType(extension);
      const file = new Blob([byteArray], {
        type: mimeType,
      });

      saveAs(file, downloadFileName);
      // const today = new Date();
      // const formattedDate = today.toISOString().split("T")[0];
      // saveAs(file, `${downloadFileName} ${formattedDate}.pdf`);
    }
  }, [fetchFileDownload, downloadFileName]);

  function addNote() {
    // Determine if the criteria has been made
    var error = false;
    // Check if note has been entered (note is not required for Fax)
    if (newNote.length === 0 && noteSelector !== "Fax" && noteSelector !== "FaxGP" && noteSelector !== "Add Report") {
      setNewNoteHelpText("You haven't typed anything!");
      error = true;
    } else {
      setNewNoteHelpText("");
    }
    // Check if subject has been entered if note is email
    if (emailSubject.length === 0 && (noteSelector === "Email" || noteSelector === "ReferrerEmail" || noteSelector === "GPEmail")) {
      setEmailSubjectHelpText("Did you forget to add a subject?");
      error = true;
    } else {
      setEmailSubjectHelpText("");
    }
    // Check if file has been added if note is fax
    if (existingFile === 0 && !(newFFile && newFFile.size > 0) && (noteSelector === "Fax" || noteSelector === "FaxGP" || noteSelector === "Add Report")) {
      setAttachmentHelpText("Did you forget to attach a file to be faxed?");
      error = true;
    } else {
      setAttachmentHelpText("");
    }
    // Check if form has been selected if note is form
    if (!sendFormID && noteSelector === "Form") {
      setFormHelpText("You must select a form. If you do not have any forms then please contact us for help.");
      error = true;
    } else {
      setFormHelpText("");
    }
    // Check if fax number has been added if note is fax
    if ((noteSelector === "Fax" || noteSelector === "FaxGP") && (!faxDestination || faxDestination.length !== 10)) {
      setFaxDestinationHelpText("Did you forget to enter a correct (ie. 10 digit) receipient fax number?");
      error = true;
    } else {
      setFaxDestinationHelpText("");
    }
    // Adding catch-all to prevent errors
    if (!noteSelector || noteSelector === "") {
      setNewNoteHelpText("You haven't typed anything!");
      error = true;
    } else {
      setNewNoteHelpText("");
    }
    // Check email in CC is actually an email address
    if (emailCC.length > 1 && !validateEmail(emailCC)) {
      setEmailCCHelpText("CC Email not valid");
      error = true;
    } else {
      setEmailCCHelpText("");
    }

    if ((noteSelector === "Request Report" || noteSelector === "Add Report") && reportType === "Not Set") {
      setReportTypeHelpText("You must select a report type.");
      error = true;
    } else {
      setReportTypeHelpText("");
    }

    // Check no errors
    if (!error) {
      // Ok time to go - move from useState to FormData
      const formData = new FormData();
      // Add fields
      var noteBody = newNote;
      if ((noteSelector === "Email" || noteSelector === "SMS") && footer) {
        noteBody = newNote + " " + footer;
      }
      formData.append("type", props.type);
      formData.append("pkid", props.pkid);
      formData.append("subject", emailSubject);
      formData.append("cc", emailCC);
      formData.append("selector", noteSelector);
      formData.append("note", noteBody);
      formData.append("faxdestination", faxDestination);
      formData.append("faxFile", newFFile);
      formData.append("existingFile", existingFile);
      formData.append("sendFormID", sendFormID);
      formData.append("csNotifyPrimary", csNotifyPrimary ? 1 : 0);
      formData.append("csNotifyAdmin", csNotifyAdmin ? 1 : 0);
      formData.append("csNotifyProvider", csNotifyProvider ? 1 : 0);
      formData.append("csNotify", 0);
      formData.append("reportType", reportType);
      // Ok Time to Dispatch
      process.env.REACT_APP_DEBUG && console.log(...formData);
      dispatch(Admin.actions.postNote({ formData: formData, type: props.type, pkID: props.pkid }));
      clearNote();
    }
  }

  function viewForm(formID) {
    // console.log(formID);
    setShow(true);
  }

  const clearNote = () => {
    setnoteSelector(props.noteAction ? props.noteAction : "Note");
    setNewNote("");
    setReportType("Not Set");
    setNewNoteHelpText("");
    setEmailSubject("");
    setEmailCC("");
    setEmailSubjectHelpText("");
    setNewFFile();
    setExistingFile(0);
    setFaxDestination("");
    setSendFormID(forms.length > 0 ? forms[0].id : 0);
    setcsNotifyPrimary(false);
    setcsNotifyAdmin(false);
    setcsNotifyProvider(false);
  };

  function uploadReport(reportType) {
    // This simply sets the reportType and noteSelector fields based on a particular note ID
    setReportType(reportType ? reportType : "Not Set");
    setnoteSelector("Add Report");
  }

  function deleteNote(noteID) {
    dispatch(Admin.actions.deleteNote({ type: props.type, pkID: props.pkid, noteID: noteID }));
  }

  function handleFileFFieldChange(propertyName, event) {
    // console.log(event.currentTarget.files[0]);
    setNewFFile(event.currentTarget.files[0]);
  }

  const handleReportTypeChange = (event) => {
    setReportType(event.target.value);
    setNewNote(`Please provide an updated ${event.target.value} report.`);
  };

  const handleSelectChange = (event) => {
    setnoteSelector(event.target.value);
    //
    // Set defaults based on selection
    //
    if (event.target.value === "FaxGP") {
      // Set fax destination to that of their GP (based on referral)
      setFaxDestination(props.faxGP);
    }
    if (event.target.value === "SMSGP") {
      // Set custom SMS message
      setNewNote(
        `Hello ${props.firstName}, Thank you for completing an appointment with Rural Health Connect. You can now book your next appointment with another practitioner. Please log in to the portal at https://portal.ruralhealthconnect.com.au to book an appointment. If you need assistance, please call us via the numbers on our website. Thank you, Rural Health Connect`,
      );
    } else {
      if (event.target.value === "SMSChg") {
        // Set custom SMS message
        setNewNote(
          `Hello ${props.firstName}, If you would like to book with a different practitioner. Please log in to the portal at https://portal.ruralhealthconnect.com.au and make a selection. If you need assistance, please call us via the numbers on our website. Thank you, Rural Health Connect`,
        );
      } else {
        if (event.target.value === "SMSCR") {
          // Set custom SMS message
          setNewNote(
            `Hello ${props.firstName}, This is a reminder to complete your registration. Please click on the link below and follow the steps <INVITEURL> . If you need assistance, please call us via the numbers on our website. Thank you, Rural Health Connect`,
          );
        } else {
          if (event.target.value === "SMSCRCL") {
            // Set custom SMS message
            setNewNote(
              `Hello ${props.firstName}, we have received a referral and been trying to connect with you to book an appointment. Can you please ring within 5 business days to discuss or complete your registration by clicking on this link <INVITEURL> . If we do not hear from you we will assume you no longer require our service and will close your referral. Please feel free to contact us at any time in the future. Kind regards, Rural Health Connect 0493 201 005 or 0493 432 144. PLEASE DO NOT REPLY TO THIS TEXT`,
            );
          } else {
            if (event.target.value === "SMSCRNC") {
              // Set custom SMS message
              setNewNote(
                `Hello ${props.firstName}, This is a reminder we have a referral for you. If you would like to book an appointment please click on the following link below to register for your telehealh sessions <INVITEURL> . If you need assistance, please call us via the numbers on our website. Thank you, Rural Health Connect`,
              );
            } else {
              if (event.target.value === "SMSCRMR") {
                // Set custom SMS message
                setNewNote(
                  `Hello ${props.firstName}, We have received your paperwork for psychology sessions however in order for you to be eligible for a Medicare rebate, we require a Mental Health Care Plan and GP referral. They can fax it to us on 0745731100. If you require assistance, please call us on 0493 201 005 or 0493 432 144. Kind regards, Rural Health Connect. PLEASE DO NOT REPLY TO THIS MESSAGE`,
                );
              } else {
                if (event.target.value === "GPEmail") {
                  // Set custom Email Message
                  setNewNote(`Dear ${props.gpName},<br> Thank you for your referral of ${props.firstName}  ${props.surname} <br><br> We have made several attempts to contact them however they have not yet signed up with our program.<br> We are therefore closing this file. <br> Please feel free to direct any questions regarding this to us at info@ruralhealthconnect.com.au or
                  call us on 0427 692 377.<br> <br> Kind Regards <br> <br> Rural Health Connect.`);
                } else {
                  if (event.target.value === "SMSADMC") {
                    // Set custom SMS message - Carly
                    setNewNote(
                      `Hi ${props.firstName}, I am  trying to contact you to book in an appointment. When you have a moment can you please call me back on 0493201005. Thanks, Carly, Rural Health Connect. PLEASE DO NOT REPLY TO THIS MESSAGE`,
                    );
                  } else {
                    if (event.target.value === "SMSADMK") {
                      // Set custom SMS message - Kass
                      setNewNote(
                        `Hi ${props.firstName}, I am  trying to contact you to book in an appointment. When you have a moment can you please call me back on 0493432144. Thanks, Kass, Rural Health Connect. PLEASE DO NOT REPLY TO THIS MESSAGE`,
                      );
                    } else {
                      if (event.target.value === "Form") {
                        // set form selection to first form if not already selected
                        if (forms && forms.length > 0) {
                          setSendFormID(forms[0].id);
                          setNewNote(`Hello ${props.firstName}, 
                          
                  You have some paperwork that needs your attention ahead of your session on Rural Health Connect.

                  Please log in to the portal at https://portal.ruralhealthconnect.com.au and complete the ${forms[0].formName} form via your dashboard.

                  Thank you,

                  Rural Health Connect`);
                        } else {
                          setNewNote(`Hello ${props.firstName}, 
                          
                  You have some paperwork that needs your attention ahead of your session on Rural Health Connect.

                  Please log in to the portal at https://portal.ruralhealthconnect.com.au and complete the form via your dashboard.

                  Thank you,

                  Rural Health Connect`);
                        }
                      } else {
                        if (event.target.value === "Request SCC") {
                          setNewNote(`Can we please request a secondary case conference on one of the following dates:

  - dd-mm-2026 between 1-5pm

  Or please suggest another day/time.`);
                        } else {
                          if (event.target.value === "Request Report") {
                            setNewNote(`Please provide an updated ${reportType} report.`);
                          } else {
                            setNewNote("");
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  };

  const handleSelectForm = (event) => {
    setSendFormID(event.target.value);
    setNewNote(`Hello ${props.firstName}, 
        
You have some paperwork that needs your attention ahead of your session on Rural Health Connect.

Please log in to the portal https://portal.ruralhealthconnect.com.au and complete the ${forms.find((row) => row.id === event.target.value).formName} form via your dashboard.

Thank you,

Rural Health Connect`);
    // setNewNote(`Please log in to the portal and complete the ${forms.find(row => row.id === event.target.value).formName} form via your dashboard.`)
  };

  const handleSelectFile = (event) => {
    setExistingFile(event.target.value);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      // minWidth: 200,
      // maxWidth: 200,
    },
    media: {
      height: 200,
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: 12,
    },
  }));

  function CSCheckboxes() {
    // Only show is specialistType is CentralisedService and in notes view
    // console.log("specialistType:", props.specialistType, "viewType:", props.viewType);
    if (props.specialistType !== "centralisedservice") {
      return null;
    }
    if (props.viewType !== "NoteOnly") {
      return null;
    }
    // If noteSelector is set to Add Report then setcsNotifyPrimary to true
    if (noteSelector === "Add Report") {
      setcsNotifyPrimary(true);
    }

    // If noteSelector is set to Request Report then setcsNotifyProvider to true
    if (noteSelector === "Request Report") {
      setcsNotifyProvider(true);
    }

    // CentralisedService specific logic
    const handleNotifyPrimaryChange = (checked) => {
      setcsNotifyPrimary(checked);
    };

    const handleNotifyAdminChange = (checked) => {
      setcsNotifyAdmin(checked);
    };

    const handleNotifyProviderChange = (checked) => {
      setcsNotifyProvider(checked);
    };

    return (
      <Row>
        <Col md="12">
          <Form.Group className="p-3 rounded bg-light border">
            {role !== "Psychologist" || (role === "Psychologist" && props.providerTotal > 1) ? (
              <Form.Check
                type="checkbox"
                checked={csNotifyProvider}
                disabled={noteSelector === "Request Report"}
                onChange={(event) => handleNotifyProviderChange(event.target.checked)}
                className="mb-3 custom-checkbox"
                label={
                  <div>
                    <strong>Notify Provider</strong>
                    <div className="text-muted fs-5 fw-light mt-1 ">
                      <span style={{ color: "#0056b3" }}>An alert will be sent to the clients provider(s).</span>
                    </div>
                  </div>
                }
              />
            ) : null}
            {role !== "CS" && role !== "CSAdmin" && (
              <Form.Check
                type="checkbox"
                checked={csNotifyPrimary}
                disabled={noteSelector === "Add Report"}
                onChange={(event) => handleNotifyPrimaryChange(event.target.checked)}
                className="mb-3 custom-checkbox"
                label={
                  <div>
                    <strong>Notify Primary Centre Contact</strong>
                    <div className="text-muted fs-5 fw-light mt-1 ">
                      <span style={{ color: "#0056b3" }}>An alert email will be sent to the clients Primary Centre Contact.</span>
                    </div>
                  </div>
                }
              />
            )}
            {role !== "Admin" && (
              <Form.Check
                type="checkbox"
                checked={csNotifyAdmin}
                onChange={(event) => handleNotifyAdminChange(event.target.checked)}
                className="mb-2 custom-checkbox"
                label={
                  <div>
                    <strong>Notify Centralised Service Admin</strong>
                    <div className="text-muted fs-5 fw-light mt-1 ">
                      <span style={{ color: "#0056b3" }}>An alert email will be sent to Centralised Service Admins.</span>
                    </div>
                  </div>
                }
              />
            )}
          </Form.Group>
        </Col>
      </Row>
    );
  }

  const classes = useStyles();

  // const getSMSDisabled = val => {
  //   //
  //   if (role !== 'Admin')
  //   {
  //     if (!smsStatus)
  //     {
  //       return {disabled: true};
  //     }
  //   }
  //   return {};
  // }

  // const getFaxDisabled = val => {
  //   //
  //   if (role !== 'Admin')
  //   {
  //     if (!faxStatus)
  //     {
  //       return {disabled: true};
  //     }
  //   }
  //   return {};
  // }

  const getFaxGPDisabled = (val) => {
    //
    // Check if provider has run out of faxes
    //
    // if (role !== 'Admin')
    // {
    //   if (!faxStatus)
    //   {
    //     return {disabled: true};
    //   }
    // }
    // Check if GP Fax has been sent
    if (!props.faxGP) {
      return { disabled: true };
    }
    return {};
  };

  const getReferrerEmailDisabled = (val) => {
    //
    // Check if Referrer Email Provided
    //
    if (!props.referrerEmail || (props.referrerEmail && props.referrerEmail.length < 0)) {
      return { disabled: true };
    }
    return {};
  };

  const getGPEmailDisabled = (val) => {
    //
    // Check if GP Email Provided
    //
    if (!props.gpEmail || (props.gpEmail && props.gpEmail.length < 0)) {
      return { disabled: true };
    }
    return {};
  };

  const getFormDisabled = (val) => {
    //
    // Check if in invite - cannot send client invites forms
    //
    if (props.type === "ClientRegistration") {
      return { disabled: true };
    }
  };

  function getActionColour() {
    if (noteSelector === "Note") {
      return "#ebfae8";
    } else if (noteSelector === "Email") {
      return "#d2f9fa";
    } else if (noteSelector === "ReferrerEmail") {
      return "#fffbc2";
    } else if (noteSelector === "GPEmail") {
      return "#ffe6ff";
    } else if (noteSelector === "SMS") {
      return "#faefcf";
    } else if (noteSelector === "SMSCR") {
      return "#00B3BE";
    } else if (noteSelector === "SMSGP") {
      return "#00B3BE";
    } else if (noteSelector === "SMSChg") {
      return "#93A33A";
    } else if (noteSelector === "SMSCRNC") {
      return "#93A33A";
    } else if (noteSelector === "SMSCRMR") {
      return "#93A33A";
    } else if (noteSelector === "SMSADMC") {
      return "#00B3BE";
    } else if (noteSelector === "SMSADMK") {
      return "#00B3BE";
    } else if (noteSelector === "Form") {
      return "#fffbc2";
    } else if (noteSelector === "Fax") {
      return "#fff0ed";
    } else if (noteSelector === "FaxGP") {
      return "#ffe6ff";
    } else if (noteSelector === "Add Report") {
      return "#e8f0fe";
    } else if (noteSelector === "Request Report") {
      return "#fff3cd";
    } else if (noteSelector === "Request SCC") {
      return "#e8def8";
    }
  }

  const showActionColumn = role === "Admin" || role === "Psychologist";

  return (
    <>
      <Grid container spacing={4}>
        <Grid item md={4}>
          <Row>
            <Col md="12">
              <Form.Group>
                <FormControl variant="outlined" margin="dense">
                  <Form.Label>Select Action</Form.Label>
                  <Select
                    id="noteSelector"
                    aria-label="Select Action Type"
                    name="noteSelector"
                    value={noteSelector}
                    onChange={handleSelectChange}
                    style={{ backgroundColor: getActionColour() }}
                  >
                    {props.viewType !== "CommunicationOnly" && (
                      <MenuItem key="Note" value="Note">
                        Record Note
                      </MenuItem>
                    )}
                    {props.viewType !== "CommunicationOnly" &&
                      props.type === "Client" &&
                      role === "Psychologist" &&
                      props.specialistType === "centralisedservice" && (
                        <MenuItem key="AddReport" value="Add Report">
                          Add Report
                        </MenuItem>
                      )}
                    {props.viewType !== "CommunicationOnly" &&
                      props.type === "Client" &&
                      (role === "Admin" || role === "CS" || role === "CSAdmin") &&
                      props.specialistType === "centralisedservice" && (
                        <MenuItem key="RequestReport" value="Request Report">
                          Request Report
                        </MenuItem>
                      )}
                    {props.viewType !== "CommunicationOnly" && props.type === "Client" && props.specialistType === "centralisedservice" && (
                      <MenuItem key="RequestSecondaryCaseConference" value="Request SCC">
                        Request Secondary Case Conference
                      </MenuItem>
                    )}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="Email" value="Email">
                        Email To Invitee
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" && props.type === "Client" && props.email && props.email.substring(0, 2) !== "04" ? (
                      <MenuItem key="Email" value="Email">
                        Email To Client
                      </MenuItem>
                    ) : null}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="GPEmail" value="GPEmail" {...getGPEmailDisabled(true)}>
                        Email To Referring GP
                      </MenuItem>
                    ) : null}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="ReferrerEmail" value="ReferrerEmail" {...getReferrerEmailDisabled(true)}>
                        Email To Referrer
                      </MenuItem>
                    ) : null}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="SMS" value="SMS">
                        SMS To {props.type === "ClientRegistration" ? "Invitee" : props.type}
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" && props.type === "Client" && props.mobilephone && props.mobilephone.substring(0, 2) === "04" ? (
                      <MenuItem key="SMS" value="SMS">
                        SMS To Client
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" &&
                    props.type === "Client" &&
                    role === "Admin" &&
                    props.mobilephone &&
                    props.mobilephone.substring(0, 2) === "04" ? (
                      <MenuItem key="SMSADMC" value="SMSADMC">
                        SMS To Client from Carly
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" &&
                    props.type === "Client" &&
                    role === "Admin" &&
                    props.mobilephone &&
                    props.mobilephone.substring(0, 2) === "04" ? (
                      <MenuItem key="SMSADMK" value="SMSADMK">
                        SMS To Client from Kass
                      </MenuItem>
                    ) : null}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="SMSCR" value="SMSCR">
                        SMS To Invitee re Registration
                      </MenuItem>
                    ) : null}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="SMSCRNC" value="SMSCRNC">
                        SMS To Invitee re No Contact
                      </MenuItem>
                    ) : null}
                    {props.type === "ClientRegistration" ? (
                      <MenuItem key="SMSCRCL" value="SMSCRCL">
                        SMS to Invitee re Close file
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" && props.type === "Client" && props.mobilephone && props.mobilephone.substring(0, 2) === "04" ? (
                      <MenuItem key="SMSCRMR" value="SMSCRMR">
                        SMS re Medicare Paperwork
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" &&
                    props.type === "Client" &&
                    role === "Admin" &&
                    props.mobilephone &&
                    props.mobilephone.substring(0, 2) === "04" ? (
                      <MenuItem key="SMSGP" value="SMSGP">
                        SMS To Client re Need to Select a Provider
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" &&
                    props.type === "Client" &&
                    role === "Admin" &&
                    props.mobilephone &&
                    props.mobilephone.substring(0, 2) === "04" ? (
                      <MenuItem key="SMSChg" value="SMSChg">
                        SMS To Client re New Provider Selection
                      </MenuItem>
                    ) : null}
                    {props.viewType !== "NoteOnly" && (
                      <MenuItem key="Form" value="Form" {...getFormDisabled(true)}>
                        Send Form to {props.type === "ClientRegistration" ? "Invitee" : props.type}
                      </MenuItem>
                    )}
                    {props.viewType !== "NoteOnly" && (
                      <MenuItem key="Fax" value="Fax">
                        Send Fax Document
                      </MenuItem>
                    )}
                    {props.viewType !== "NoteOnly" && (
                      <MenuItem key="FaxGP" value="FaxGP" {...getFaxGPDisabled(true)}>
                        Send Fax to Client GP
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Form.Group>
            </Col>
          </Row>

          {/* REPORT TYPE NOTE */}
          {(noteSelector === "Add Report" || noteSelector === "Request Report") && (
            <Row>
              <Col md="12">
                <div
                  style={{
                    marginBottom: 20,
                    padding: "10px 12px",
                    backgroundColor: getActionColour(),
                    border: "1px solid #ddd",
                    borderRadius: 4,
                    fontSize: 14,
                    lineHeight: 1.5,
                  }}
                >
                  Reports are to be requested when a written update is needed for a client file or similar. For an update on consumer progress, please consider
                  a secondary case conference.
                </div>
              </Col>
            </Row>
          )}

          {/* REPORT TYPE */}
          {(noteSelector === "Request Report" || noteSelector === "Add Report") && (
            <Row>
              <Col md="12">
                <Form.Group>
                  <FormControl variant="outlined" margin="dense">
                    <Form.Label>Report Type</Form.Label>
                    <Select
                      id="reportTypeSelector"
                      aria-label="Select Report Type"
                      name="reportTypeSelector"
                      value={reportType}
                      onChange={handleReportTypeChange}
                      style={{ backgroundColor: getActionColour() }}
                    >
                      <MenuItem key="None" value="Not Set">
                        Select Report Type
                      </MenuItem>
                      <MenuItem key="TreatmentGoals" value="Treatment Plan">
                        Treatment Plan
                      </MenuItem>
                      <MenuItem key="ProgressReport" value="Progress Report">
                        Progress Report
                      </MenuItem>
                      <MenuItem key="TreatmentDischarge" value="Treatment Discharge">
                        Treatment Discharge
                      </MenuItem>
                    </Select>
                    {reportTypeHelpText && <p className="error-help">{reportTypeHelpText}</p>}
                  </FormControl>
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* SUBJECT FIELD */}
          {(noteSelector === "Email" || noteSelector === "ReferrerEmail" || noteSelector === "GPEmail") && (
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Subject</Form.Label>
                  <Form.Control type="text" defaultValue={emailSubject} onBlur={(e) => setEmailSubject(e.target.value)} style={{ backgroundColor: "white" }} />
                  {emailSubjectHelpText && <p className="error-help">{emailSubjectHelpText}</p>}
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* CC FIELD */}
          {(noteSelector === "Email" || noteSelector === "ReferrerEmail" || noteSelector === "GPEmail") && (
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>CC</Form.Label>
                  <Form.Control type="text" defaultValue={emailCC} onBlur={(e) => setEmailCC(e.target.value)} style={{ backgroundColor: "white" }} />
                  {emailCCHelpText && <p className="error-help">{emailCCHelpText}</p>}
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* FAX DESTINATION */}
          {(noteSelector === "Fax" || noteSelector === "FaxGP") && (
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Recipient Fax Number</Form.Label>
                  <Form.Control type="text" defaultValue={faxDestination} onBlur={(e) => setFaxDestination(e.target.value)} />
                  {faxDestinationHelpText && <p className="error-help">{faxDestinationHelpText}</p>}
                  <Form.Text muted>{props.medicalPractice && `${props.medicalPractice.practicename} - ${props.medicalPractice.fax}`}</Form.Text>
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* FORM SELECTION */}
          {noteSelector === "Form" && (
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>
                    Select Form{" "}
                    <span onClick={() => viewForm(sendFormID)} style={{ cursor: "pointer", fontWeight: 600 }}>
                      (Preview)
                    </span>
                  </Form.Label>
                  <FormControl margin="dense">
                    <Select value={sendFormID} onChange={handleSelectForm} style={{ backgroundColor: "white" }}>
                      {forms.map((f) => (
                        <MenuItem key={f.id} value={f.id}>
                          {f.formName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  {formHelpText && <p className="error-help">{formHelpText}</p>}
                </Form.Group>
              </Col>
            </Row>
          )}

          {/* ATTACHMENT UPLOAD */}
          {(() => {
            if (
              noteSelector === "Fax" ||
              noteSelector === "FaxGP" ||
              noteSelector === "Email" ||
              noteSelector === "ReferrerEmail" ||
              noteSelector === "GPEmail" ||
              noteSelector === "Add Report"
            ) {
              return (
                <Row>
                  <Col md="12">
                    <Form.Label>{noteSelector === "Add Report" ? "Upload Report" : "Select an Existing File or Upload"}</Form.Label>
                    <Form.Group>
                      {noteSelector !== "Add Report" && (
                        <FormControl>
                          <Select value={existingFile} onChange={handleSelectFile} style={{ backgroundColor: "white", width: "100%", marginBottom: 20 }}>
                            <MenuItem value={0}>Not Selected</MenuItem>
                            {loadFiles.map((file) => (
                              <MenuItem key={file.id} value={file.id}>
                                {file.filename}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      )}

                      {existingFile === 0 && (
                        <>
                          <Form.Control type="file" onChange={(e) => handleFileFFieldChange("newfile", e)} />
                          {newFFile && `Selected: ${newFFile.name}`}
                        </>
                      )}

                      {attachmentHelpText && <p className="error-help">{attachmentHelpText}</p>}
                    </Form.Group>
                  </Col>
                </Row>
              );
            }
          })()}

          {/* MESSAGE FIELD */}
          {(() => {
            if (noteSelector === "Fax" || noteSelector === "FaxGP" || noteSelector === "Add Report") return null;

            if (noteSelector.includes("Email")) {
              return (
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Message</Form.Label>
                      <ReactQuill theme="snow" value={newNote} onChange={setNewNote} />
                      {newNoteHelpText && <p className="error-help">{newNoteHelpText}</p>}
                    </Form.Group>
                  </Col>
                </Row>
              );
            }

            return (
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control as="textarea" rows={6} value={newNote} onChange={(e) => setNewNote(e.target.value)} />
                    {newNoteHelpText && <p className="error-help">{newNoteHelpText}</p>}
                  </Form.Group>
                </Col>
              </Row>
            );
          })()}

          <CSCheckboxes />

          {/* FOOTER */}
          {(noteSelector === "Email" || noteSelector === "SMS") && props.type !== "ClientRegistration" && (
            <Form.Group>
              <Form.Label>Footer (Waiting Room URL)</Form.Label>
              <Form.Control type="text" defaultValue={footer} onBlur={(e) => setFooter(e.target.value)} style={{ backgroundColor: "white" }} />
            </Form.Group>
          )}

          <Row>
            <Col md="12">
              <Grid container spacing={0} padding={6} justifyContent="space-between">
                <Button variant="light" size="sm" onClick={() => clearNote()} style={{ borderColor: "#D1D1D1" }}>
                  Clear
                </Button>
                <Button variant="success" size="sm" onClick={() => addNote()}>
                  {noteSelector === "Note" ? "Save" : "Send"}
                </Button>
              </Grid>
            </Col>
          </Row>
        </Grid>
        <Grid item md={8}>
          <Form.Group>
            <Form.Label>Notes</Form.Label>
            <TableContainer style={{ backgroundColor: "#FFF", height: 540, width: "100%", overflowY: "scroll" }}>
              <Table className={classes.table} aria-label="simple table" style={{ tableLayout: "fixed", width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: 100, whiteSpace: "normal", wordBreak: "break-word" }}>Date</TableCell>
                    <TableCell style={{ width: 100, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>Source</TableCell>
                    {viewType !== "NoteOnly" && (
                      <TableCell style={{ width: 80, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>Type </TableCell>
                    )}
                    <TableCell>Note</TableCell>
                    {(role === "Admin" || role === "Psychologist") && (
                      <TableCell style={{ width: 70, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>Action</TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notesToDisplay
                    ? notesToDisplay.map((row) => (
                        <TableRow key={row.id}>
                          <TableCell
                            style={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              textAlign: "center",
                            }}
                          >
                            {format(new Date(row.createdOn), "dd-MM-yyyy")}
                            <br />
                            {format(new Date(row.createdOn), "HH:mm")}
                          </TableCell>
                          <TableCell style={{ width: 100, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>{row.createdBy}</TableCell>
                          {viewType !== "NoteOnly" && (
                            <TableCell style={{ width: 80, whiteSpace: "normal", wordBreak: "break-word", textAlign: "center" }}>{row.action}</TableCell>
                          )}
                          <TableCell>
                            {row.note.split(/\r?\n/).map((line, index) => {
                              if (line.startsWith("Template: ")) {
                                const url = line.substring("Template: ".length);

                                return (
                                  <div key={index}>
                                    <a href={url} target="_blank" rel="noopener noreferrer">
                                      Open Template
                                    </a>
                                  </div>
                                );
                              }

                              if (line.startsWith("File: ") && row.reportFileID) {
                                const filename = line.substring("File: ".length);

                                const fileRow = {
                                  ...row,
                                  filename: filename,
                                };

                                return (
                                  <div key={index}>
                                    <Tooltip title={`Download ${filename}`} aria-label="Download" placement="top" arrow>
                                      <span
                                        style={{
                                          display: "inline-block",
                                          marginRight: 6,
                                          verticalAlign: "middle",
                                          cursor: "pointer",
                                          color: "#1976d2",
                                        }}
                                      >
                                        {activeFileDownloadId === row.reportFileID ? (
                                          <CircularProgress size={18} />
                                        ) : (
                                          <CloudDownload
                                            style={{
                                              color: "#1976d2",
                                              cursor: "pointer",
                                              verticalAlign: "middle",
                                            }}
                                            onClick={() => handleFileDownload(fileRow)}
                                          />
                                        )}
                                      </span>
                                    </Tooltip>

                                    <span
                                      style={{
                                        color: "#1976d2",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleFileDownload(fileRow)}
                                    >
                                      {filename}
                                    </span>
                                  </div>
                                );
                              }
                              return <div key={index}>{line}</div>;
                            })}
                          </TableCell>
                          {showActionColumn && (
                            <TableCell
                              style={{
                                width: 70,
                                whiteSpace: "normal",
                                wordBreak: "break-word",
                                textAlign: "center",
                              }}
                            >
                              {role === "Admin" ||
                                (role === "Psychologist" && row.action === "Add Report" && (
                                  <IconButton edge="end" aria-label="delete">
                                    <DeleteIcon onClick={() => deleteNote(row.id)} />
                                  </IconButton>
                                ))}

                              {role === "Psychologist" && row.action === "Request Report" && row.reportType && (
                                <IconButton edge="end" aria-label="Upload Report">
                                  <PublishIcon onClick={() => uploadReport(row.reportType)} />
                                </IconButton>
                              )}
                            </TableCell>
                          )}
                        </TableRow>
                      ))
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Form.Group>
        </Grid>
      </Grid>

      <Modal show={show} onHide={() => setShow(false)} dialogClassName="edit-md-modal">
        <Modal.Header className="edit-md-modal">
          <Modal.Title>View Form</Modal.Title>
          <CloseIcon onClick={() => setShow(false)} style={{ cursor: "pointer" }} />
        </Modal.Header>
        <Modal.Body className="edit-md-modal">
          <FormDataEntry setFormID={sendFormID} formID={sendFormID} formDataID={0} setShowFormData={setShow} />
        </Modal.Body>
      </Modal>
    </>
  );
}
